<template>
  <case :banner="Banner" :box1="box1" :box2="box2">
    <v-row>
      <v-col cols="12">
        <highlight-container even class="pa-0">
          <p class="text-body" v-html="intro" />
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container
          even
          class="pa-0"
          title="Resultados com o selo eureciclo"
        >
          <v-list dense>
            <v-list-item v-for="(result, i) in results" :key="i">
              <v-list-item-icon>
                <v-img
                  :src="require('@/assets/images/materialicons/check.svg')"
                />
              </v-list-item-icon>
              <v-list-item-content
                class="text-body"
                :style="{ color: color }"
                v-html="result"
              />
            </v-list-item>
          </v-list>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container class="pa-0" even title="O desafio da marca">
          <div class="text-body">
            <p>
              Em um mercado de suplementos alimentares no qual as próprias
              indústrias de Whey criaram o estigma de que aproteína é "bomba", a
              +Mu queria aparecer como uma marca de suplementos naturais e
              saudáveis. Para isso, voltou suas estratégias de marketing para
              lembrar do leite, dando um viés de naturalidade ao produto. É daí
              que vem a famosa vaquinha!
            </p>
            <p>
              Apesar de não ser seu maior propósito, a marca queria se aproximar
              um pouco mais do movimento de sustentabilidade, de reciclagem e de
              se preocupar com toda a cadeia, porque acreditam na importância e
              no valor disso. Mas o grande problema é que eles não sabiam como
              se engajar mais nessa causa. Foi aí que a solução do selo entrou e
              encaixou muito bem nas necessidades da marca, principalmente no
              quesito de reduzir o impacto das garrafinhas plásticas, seu
              produto que tem maior venda.
            </p>
            <p>
              A escolha do selo também aconteceu pela abordagem da
              eu<b>reciclo</b>. A +Mu se conectou bastante com a pegada jovem do
              selo que surgia há pouco tempo no mercado e, por sentir uma
              sintonia com a causa entre todos os nossos parceiros, acreditaram
              que o selo contribuiria de forma muito positiva com a marca.
            </p>
          </div>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container even class="pa-0">
          <v-card :color="colorCard">
            <v-card-text class="text-body pa-md-10" style="color: #fff">
              <p>
                {{ featuredbox.text }}
              </p>
              <p class="author">
                {{ featuredbox.author }}
              </p>
            </v-card-text>
          </v-card>
        </highlight-container>
      </v-col>
      <v-col cols="12">
        <highlight-container even class="pa-0" title="Como o selo contribuiu">
          <div class="text-body">
            <p>
              A adoção do selo possibilitou a resolução de uma objeção que os
              consumidores tinham, oferecendo uma solução para um problema que
              atingia diretamente as vendas da +Mu. As pessoas se sentiam mal em
              consumir um produto de uso único e logo depois descartar a
              embalagem. Com o selo, a marca teve a possibilidade de explicar
              para os consumidores o trabalho de compensação que é realizado com
              as embalagens, dando mais segurança para eles consumirem o produto
              sabendo que o impacto causado seria compensado.
            </p>
            <p>
              E o legal é que os consumidores reconhecem o selo na embalagem,
              percebendo a diferença que a parceria consegue proporcionar. Isso
              pode ser visto nas campanhas que a eu<b>reciclo</b> promove, como
              a Caça ao Sorriso, que incentiva o consumidor a procurar o selo
              nas embalagens e postar nas suas redes sociais. A +Mu é uma das
              marcas que mais aparece nas marcações dos consumidores, como esses
              daqui:
            </p>
            <v-row class="py-5" justify="center">
              <v-col cols="4" md="3">
                <v-img class="rounded-image" :src="Foto1" />
              </v-col>
              <v-col cols="4" md="3">
                <v-img class="rounded-image" :src="Foto2" />
              </v-col>
              <v-col cols="4" md="3">
                <v-img class="rounded-image" :src="Foto3" />
              </v-col>
            </v-row>
            <p>
              Atualmente, a empresa não para de crescer, já tendo atingido um
              crescimento 4 vezes maior em relação ao ano anterior. É referência
              no que diz respeito à suplementação saudável e já possuem diversos
              pontos de venda espalhados pelo Brasil. Através da parceria com o
              selo, conseguem cumprir com a Política Nacional de Resíduos
              Sólidos, e já auxiliaram 4 cooperativas com a compensação de quase
              meia tonelada de resíduos desde 2017.
            </p>
            <div class="py-5">
              <v-img :src="Foto4" contain width="100%" max-height="350" />
            </div>
          </div>
        </highlight-container>
      </v-col>
    </v-row>
  </case>
</template>

<script>
export default {
  name: 'MaisMu',
  metaInfo: {
    title: 'Case +Mu',
  },
  components: {
    Case: () => import('@/components/Case.vue'),
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
  },
  data() {
    return {
      Banner: require('@/assets/images/cases/maismu/banner.jpg'),
      Foto1: require('@/assets/images/cases/maismu/foto1.jpg'),
      Foto2: require('@/assets/images/cases/maismu/foto2.jpg'),
      Foto3: require('@/assets/images/cases/maismu/foto3.jpg'),
      Foto4: require('@/assets/images/cases/maismu/foto4.jpg'),
      box1: {
        title: 'Sobre a +Mu',
        text: `A +Mu nasceu no final de 2014, com a missão de democratizar a proteína do leite. Para isso, mostra qual
              é a real origem do Whey, disseminando a ideia de que não é maléfico à saúde dos consumidores que não são
              extremamente adeptos aos esportes. Através de maneiras práticas, saborosas, nutritivas e criativas,
              atingem todo um público mais engajado e preocupado com a saúde. No último ano, teve um crescimento de
              mais de 4 vezes, conseguindo ter grande visibilidade no mercado.`,
      },
      box2: {
        title: 'Selo eureciclo',
        text: `Faça como a +Mu e torne-se uma empresa mais sustentável! Com o selo eu<b>reciclo</b>, sua empresa compensa o
              impacto das suas embalagens e adequa-se à legislação, além de incentivar o desenvolvimento da cadeia
              de reciclagem no Brasil e comunicar aos seus consumidores o seu engajamento.`,
        eventLabel: 'case-maismu',
      },
      intro: `Através da compensação ambiental feita pelo selo eu<b>reciclo</b>, a +Mu solucionou a objeção que seus
              consumidores tinham em relação às garrafinhas de plástico de uso único, compensando seu impacto
              no meio ambiente.`,
      results: [
        `Incentivou a coleta, a triagem e a destinação de massas proporcionais aos materiais da embalagem de seus
        produtos: 22,0% do Plástico, 22,2% do Papel.`,
        'Resíduos compensados pelas cooperativas: 465Kg de plástico; 167Kg de papel',
        'A empresa beneficiou 4 cooperativas reciclagem de dois estados: SP e MG',
      ],
      featuredbox: {
        text: `“Nós não nascemos com esse propósito de sustentabilidade, reciclagem e preocupação com toda cadeia dos
              materiais, mas acreditamos muito nessa causa e nessas ideias. Queríamos nos engajar um pouco mais nesse
              tema, mas não sabíamos como. Foi aí que o selo surgiu de uma maneira muito legal para gente,
              principalmente por causa do nosso produto de maior saída que são as garrafinhas de plástico de uso único”.`,
        author: 'Antonio Neto, fundador +Mu',
      },
      color: '#59595c !important',
      colorCard: '#01ee55',
    };
  },
  mounted() {
    this.checkClass();
  },
  methods: {
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#003036 !important';
        this.colorCard = '#26d07c';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/styles/util"
@import "@/styles/style"
</style>
